
import * as ContractModels from '../../models/contract/contract';
import * as Models from "../../models/commonModels";


export class GetList {
  static readonly type = "[Contract] GetList";
  constructor(public Search: ContractModels.ContractSearchModel) { }
}

export class SetContractSearch {
  static readonly type = "[Contract] SetContractSearch";
  constructor(public Search: ContractModels.ContractSearchModel) { }
}

export class SetContractListPage {
  static readonly type = "[Contract] SetCustomerListPage";
  constructor(public Search: ContractModels.ContractSearchModel) { }
}

export class ResetContractSearch {
  static readonly type = "[Contract] ResetContractSearch";
  constructor() { }
}

export class Set {
  static readonly type = "[Contract] Set";
  constructor(public Set: Models.Request<ContractModels.ContractModel>) { }
}

export class SetStatus {
  static readonly type = "[Contract] SetStatus";
  constructor(public Set: Models.Request<ContractModels.ContractModel>) { }
}

export class Active {
  static readonly type = "[Contract] Active";
  constructor(public Set: Models.Request<ContractModels.ContractModel>) { }
}

export class Create {
  static readonly type = "[Contract] Create";
  constructor(public Create: Models.Request<ContractModels.ContractModel>) { }
}

export class Get {
  static readonly type = "[Contract] Get ";
  constructor(public Contract: Models.RequestModel) { }
}

export class GetActiveForCustomer {
  static readonly type = "[Contract] GetActiveForCustomer ";
  constructor(public Contract: Models.RequestModel) { }
}

export class PublishSend {
  static readonly type = "[Contract] Publish Send";
  constructor(public Contract: Models.Request<ContractModels.ContractPreviewModel>) { }
}

export class SendAgain {
  static readonly type = "[Contract] Send Again";
  constructor(public Contract: Models.Request<ContractModels.ContractPreviewModel>) { }
}

export class ApproveForClient {
  static readonly type = "[Contract] Approve For Client";
  constructor(public Contract: Models.Request<ContractModels.ContractPreviewModel>) { }
}

export class Download {
  static readonly type = "[Contract] Download";
  constructor(public Contract: Models.Request<ContractModels.ContractPreviewModel>) { }
}

export class GetDiscount {
  static readonly type = "[Contract] Get Discount ";
  constructor(public Contract: Models.Request<ContractModels.ContractDiscountSearch>) { }
}

export class SetContractDiscount {
  static readonly type = "[Contract] Set Discount ";
  constructor(public Discount: Models.Request<ContractModels.SetContractDiscountPreviewModel>) { }
}

export class GetGarages {
  static readonly type = "[Contract] Get Garages ";
  constructor(public Search: Models.RequestModel) { }
}

export class GetContractGarageServicePrice {
  static readonly type = "[Contract] Get Service Price List ";
  constructor(public Search: ContractModels.ContractGarageServicePriceSearchModel) { }
}

export class SetContractGarageServicePrice {
  static readonly type = "[Contract] Set Service Price List ";
  constructor(public Set: Models.Request<ContractModels.SetContractGarageServicePriceModel>) { }
}

export class ClearContractGarageServicePrice {
  static readonly type = "[Contract] Clear Service Price List ";
  constructor(public Clear: ContractModels.ContractGarageServicePriceSearchModel) { }
}

export class GetExtraParametersList {
  static readonly type = "[Contract] Get Extra Parameters";
  constructor(public Contract: Models.RequestModel) { }
}

export class SetExtraParameters {
  static readonly type = "[Contract] Set Extra Parameters ";
  constructor(public Parameter: Models.Request<ContractModels.ContractExtraParameterModel>) { }
}

export class RemoveExtraParameters {
  static readonly type = "[Contract] Remove Extra Parameters ";
  constructor(public Parameter: Models.Request<ContractModels.ContractExtraParameterModel>) { }
}

export class GetPreviousContract {
  static readonly type = "[Contract] Get PreviousContract ";
  constructor(public Contract: Models.RequestModel) { }
}

export class GetContractDiscountExcelReport {
  static readonly type = "[Contract] Get Contract Discount Excel Report";
  constructor(public ReportName: string, public Search: Models.RequestModel) { }
}

export class ImportContractDiscountList {
  static readonly type = '[Contract] Import Contract Discount';
  constructor(public FileName: string, public Data: any) { }
}

export class SetImportContractDiscountStatus {
  static readonly type = '[Contract] Set Import Contract Discount Status';
  constructor(public Status: boolean) { }
}

export class GetContractPriceListExcelReport {
  static readonly type = "[Contract] Get Contract Price List Excel Report";
  constructor(public ReportName: string, public Search: ContractModels.ContractGarageServicePriceSearchModel) { }
}

export class ImportContracPriceList {
  static readonly type = '[Contract] Import Contract Price List';
  constructor(public FileName: string, public Data: any) { }
}

export class SetImportContractPriceListStatus {
  static readonly type = '[Contract] Set Import Contract Price List Status';
  constructor(public Status: boolean) { }
}

export class GetSubCustomerPriceItems {
  static readonly type = '[Contract] Get Sub Customer Price List';
  constructor(public Search: ContractModels.ContractSubCustomerPriceSearch) { }
}

export class SetSubCustomerPriceItems {
  static readonly type = '[Contract] Set Sub Customer Price List';
  constructor(public Set: Models.Request<ContractModels.ContractSubCustomerPricePreviewModel>) { }
}

export class RemoveSubCustomerPriceItems {
  static readonly type = '[Contract] Remove Sub Customer Price List';
  constructor(public Remove: Models.Request<ContractModels.ContractSubCustomerPricePreviewModel>) { }
}
export class GetContractSubCustomerExtraParametersItems {
  static readonly type = '[Contract] Get Sub Customer Extra Parameters List';
  constructor(public Search: ContractModels.ContractSubCustomerExtraParametersSearch) { }
}

export class SetContractSubCustomerExtraParametersItems {
  static readonly type = '[Contract] Set Sub Customer Extra Parameters';
  constructor(public Set: Models.Request<ContractModels.ContractSubCustomerExtraParametersPreviewModel>) { }
}

export class RemoveContractSubCustomerExtraParametersItems {
  static readonly type = '[Contract] Remove Sub Customer Extra Parameters';
  constructor(public Remove: Models.Request<ContractModels.ContractSubCustomerExtraParametersPreviewModel>) { }
}

export class SetDocumentFile {
  static readonly type = '[Contract] Set Document File';
  constructor(public Contract: Models.Request<ContractModels.ContractModel>, public File: File) { }
}

export class GetDocumentFile {
  static readonly type = '[Contract] Get Document File';
  constructor(public Contract: Models.Request<ContractModels.ContractModel>) { }
}

export class GetCarCurrent {
  static readonly type = "[Contract] Get Car Current";
  constructor(public Car: Models.RequestModel) { }
}
